import { useTranslate } from '@growtherapy/i18n';
import { DrawerTitle } from '@growtherapy/sprout-ui';

import { PaginatedDrawer, PaginatedDrawerProps } from '..';
import { type MeasureSchemaAndAnswers } from './types';

export function MeasuresDrawer(
  props: Omit<PaginatedDrawerProps<MeasureSchemaAndAnswers>, 'headerComponent' | 'contentOnly'>,
) {
  return <PaginatedDrawer {...props} headerComponent={Header} contentOnly />;
}

function Header() {
  const t = useTranslate();
  return <DrawerTitle>{t('telehealth-core:waitingRoom.completingMeasure')}</DrawerTitle>;
}
